import { buildCollection } from "@firecms/core";

export const winConditionGroupsCollection = buildCollection({
  name: "Win Condition Groups",
  id: "win_condition_groups",
  path: "win_condition_groups",
  icon: "stadium",
  group: "Win Condition",
  textSearchEnabled: true,
  properties: {
    name: {
      name: "Name",
      dataType: "string",
      validation: {
        required: true,
      },
    },
    individual_win_conditions: {
      name: "Individual Win Conditions",
      dataType: "boolean",
      defaultValue: true,
    },
    win_conditions: {
      name: "Win Conditions",
      dataType: "array",
      of: {
        dataType: "reference",
        path: "win_condition",
      },
    },
    product_identifier: {
      name: "Product Identifier",
      dataType: "string",
      validation: {
        lowercase: true,
        trim: true,
      },
    },
    sort_index: {
      name: "Sort Index",
      dataType: "number",
      validation: {
        integer: true,
        positive: true,
      },
    },
    tags: {
      name: "Tags",
      dataType: "array",
      of: {
        dataType: "string",
        validation: {
          lowercase: true,
        },
      },
    },
  },
});
